<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :hide-title="hideTitle" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :card-height="cardHeight" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    import operationEnum from '../enums/operation'
    import enumService from '../services/enumService'

    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'cardHeight',
            'isHover',
            'hideTitle'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                contactForm: () => import('../forms/ContactForm'),
                fields: [
                    { type: 'contact', value: 'contact', contactField: 'contactId', rules: { name: v => !!v || 'Name is required', emailAddress: v => !!v || 'Email is required' }, noEditEmailAddress: !this.hasRole('Admin') },
                    { type: 'number', text: 'Membership Number', value: 'membershipNumber', rules: [v => (v !== null && v !== '') || 'Membership Number is required', v => (v < 2147483647) || 'Maximum value reached'], isRequired: true },
                    { type: 'checkbox', text: 'Is B-TRACE', value: 'isBtrace', rules: [v => (v !== null && v !== '') || 'Is B-TRACE is required'], isRequired: true },
                    { type: 'date', text: 'First Audit On', value: 'firstAuditOn', rules: [] },
                    { type: 'enum', text: 'Operation', value: 'operations', rules: [v => (v !== null && v !== '') || 'Member Operation is required'], isRequired: true, isMultiple: true, items: enumService.enumAsSelectList(operationEnum) },
                    { type: 'file', text: 'Code of Practice Declaration File', value: 'codeOfPracticeDeclarationFileId', rules: [], form: () => import('./FileForm'), apiMethod: 'Files' },
                ],
                apiMethod: 'Members',
                formTitle: 'Member',
            }
        }
    };
</script>
